<ng-container [ngSwitch]="state">
    <ng-container *ngSwitchCase="'ok'">
        <mat-icon class="mat-primary span-align">check_circle</mat-icon>
    </ng-container>
    <ng-container *ngSwitchCase="'alert'">
        <mat-icon class="mat-accent span-align">warning</mat-icon>
    </ng-container>
    <ng-container *ngSwitchCase="'danger'">
        <mat-icon class="mat-warn span-align">cancel</mat-icon>
    </ng-container>
</ng-container>